
export default {
    name: 'BaseButton',

    props: {
        variant: {
            type: String,
            default: 'primary',
            validator: function (value) {
                return [
                    'convert',
                    'primary',
                    'secondary',
                    'tertiary',
                    'primary-inverted',
                    'secondary-inverted',
                    'filter',
                    'danger',
                    'toggle',
                    'underline',
                    'dark',
                    'clean',
                ].includes(value)
            },
        },
        size: {
            type: String,
            default: 'medium',
            validator: function (value) {
                return ['small', 'medium', 'large'].includes(value)
            },
        },
        type: {
            type: String,
            default: 'button',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isConfirmed: {
            type: Boolean,
            default: false,
        },
        faIcon: {
            type: String,
            default: '',
        },
        faIconRight: {
            type: String,
            default: '',
        },
        slotWrapperClass: {
            type: String,
            default: '',
        },
        customConfirming: {
            type: Boolean,
            default: false,
        },
        asIcons: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showConfirmationAnimation: false,
        }
    },

    computed: {
        variantClass() {
            const map = {
                convert: 'btn-new-convert',
                primary: 'btn-new-primary',
                secondary: 'btn-new-secondary',
                tertiary: 'btn-new-tertiary',
                'primary-inverted': 'btn-new-primary-inverted',
                'secondary-inverted': 'btn-new-secondary-inverted',
                filter: 'btn-new-filter',
                danger: 'btn-new-danger',
                toggle: 'btn-new-toggle',
                underline: 'btn-new-underline',
                dark: 'btn-new-dark',
                clean: 'btn-new-clean',
            }

            return map[this.variant]
        },
        sizeClass() {
            const map = {
                small: 'btn-new-small',
                large: 'btn-new-large',
            }

            return map[this.size]
        },

        hasDefaultSlot() {
            return !!this.$slots.default
        },
    },

    watch: {
        isConfirmed(value) {
            this.showConfirmationAnimation = value
        },

        showConfirmationAnimation(val) {
            if (this.customConfirming) {
                return
            }

            if (val === true) {
                setTimeout(() => {
                    this.showConfirmationAnimation = false
                    this.$emit('confirmed')
                }, 1000)
            }
        },
    },
}
